import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=4bc24bdc&scoped=true&"
import script from "./topBar.vue?vue&type=script&lang=js&"
export * from "./topBar.vue?vue&type=script&lang=js&"
import style0 from "./topBar.vue?vue&type=style&index=0&id=4bc24bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc24bdc",
  null
  
)

export default component.exports